var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };} /** @format */

import * as React from 'react';
import { connect } from 'react-redux';
import { NeedAuthorization } from "../../Auth";






const FeatureToggleSemanticSearch = ({
  semanticSearchActivated,
  children
}) =>
semanticSearchActivated ? /*#__PURE__*/
_jsx(NeedAuthorization, { roles: ['admin'] }, void 0, children) :
null;

FeatureToggleSemanticSearch.defaultProps = {
  semanticSearchActivated: false
};

export function mapStateToProps({ settings }) {
  const features = settings.collection.toJS().features || {};
  return {
    semanticSearchActivated: features.semanticSearch
  };
}

const container = connect(mapStateToProps)(FeatureToggleSemanticSearch);
export { container as FeatureToggleSemanticSearch };